export { default as images } from "./images";
export { default as data } from "./data";

export const EMPLOYEES_ROLES=[
  'admin',
  'employee'
];

export const DISTRIBUTOR_ROLE=["super-stockist", "distributor"];

export const GROOVY_GROUP_PRODUCTS=['groovy-plus','groovy','water'];

export const PAGINATION_SEQUENCE=[10, 25, 50,100,200, 500, 1000, 2000, 5000, 10000];

export const employeeFileHeaders = [
  "fullName",
  "email",
  "phone",
  "address.city",
  "address.state",
  "address.pincode",
  "approved",
  "isLogged"
];

export const employeeHeaderMapping: { [key: string]: string } = {
  fullName: "Full Name",
  email: "Email",
  phone: "Phone",
  "address.city": "City",
  "address.state": "State",
  "address.pincode": "Pincode",
  approved: "Approved",
  isLogged: "Status"
};

export const shopFileHeaders = [
  "shopName",
  "shopOwner",
  "shopAddress",
  "shopCity",
  "shopState",
  "shopContactNumber",
  "createdBy",
  "addedAt"
];

export const shopHeaderMapping: { [key: string]: string } = {
  shopName: "Shop Name",
  shopOwner: "Shop Owner",
  shopAddress: "Address",
  shopCity: "City",
  shopState: "State",
  shopContactNumber: "Contact Number",
  createdBy:"Created By",
  addedAt: "Added At"
};


export const saleFileHeaders = [
  "employee.fullName",
  "shop.shopName",
  "shop.shopOwner",
  "shop.shopAddress",
  "shop.shopCity",
  "shop.shopState",
  "shop.shopContactNumber",
  "distributor",
  "totalCases",
  "isAvailable",
  "addedAt"
];

export const saleHeaderMapping: { [key: string]: string } = {
  "employee.fullName":"Employee Name",
  "shop.shopName": "Shop Name",
  "shop.shopOwner": "Shop Owner",
  "shop.shopAddress": "Address",
  "shop.shopCity": "City",
  "shop.shopState": "State",
  "shop.shopContactNumber": "Shop Contact Number",
  "distributor":"Distributor",
  "totalCases":"Orders",
  "isAvailable":"Available",
  addedAt: "Added At"
};


export const tripFileHeaders = [
  "startAt",
  "endAt",
  "startingAddress",
  "endingAddress",
  "tripPlan",
  "employee",
  "workingArea"
];

export const tripHeaderMapping: { [key: string]: string } = {
  startAt: "Start At",
  endAt: "End At",
  startingAddress: "Starting Address",
  endingAddress: "Ending Address",
  tripPlan: "Trip Plan",
  employee: "Employee",
  workingArea: "Working Area"
}; 

export const ATTENDANCE_STATUS=['absent', 'present'];


export const PRODUCT_GROUPS=[
  { label: "all", value: "all" },
  { label: "Groovy", value: "groovy" },
  { label: "Groovy Plus", value: "groovy-plus" },
  { label: "Water", value: "water" },
];

export const attendanceHeaders = [
  "employee.fullName",
  "employee.address.city",
  "employee.address.state",
  "date",
  "employee.isLogged",
  "employee.appVersion"
];

export const attendanceHeaderMapping: { [key: string]: string } = {
  "employee.fullName": "Fullname",
  "employee.address.city": "City",
  "employee.address.state": "State",
  "date":"Logged At",
  "employee.isLogged": "Logged In",
  "employee.appVersion":"App Version"
};

export const EMPLOYEE_STATUS=[
  { label: "Approved", value: "true" },
  { label: "Rejected", value: "false" },
];

export const REPORT_TYPE=[
  { label: "Attendance", value: "attendance" },
  { label: "Employee Performance", value: "employee_performance" },
  { label: "Party Details", value: "party_details" },
];

// attendance report
export const attendanceReportHeaders = [
  "name",
  "designation",
  "state",
  "reporter",
  "present",
  "lateMark",
  "totalShopsCreated",
  "totalShopVisited",
  "productiveOutlet",
  "totalSales",
  "totalDistanceCovered",
  "totalDistanceGoogle"
];

export const attendanceReportHeaderMapping: { [key: string]: string } = {
  "name": "Employee",
  "designation": "Role",
  "state": "State",
  "reporter":"Reporting",
  "present":"Present",
  "lateMark": "Late Mark",
  "totalShopsCreated":"MTD Outlet",
  "totalShopVisited":"MTD Outlet Visited",
  "productiveOutlet":"Productive Outlet",
  "totalSales":"MTD Sales",
  "totalDistanceCovered":"Total Travel (KM)",
  "totalDistanceGoogle":"Total Distance Google (KM)"
};

// attendance time detail report
export const attendanceTimeDetailReportHeaders = [
  "date",
  "status",
  "trips.startingAddress",
  "trips.startAt",
  "trips.endingAddress",
  "trips.endAt",
  "trips.totalDistance",
];

export const attendanceTimeReportHeaderMapping: { [key: string]: string } = {
  "date": "Date",
  "status": "Status",
  "trips.startingAddress": "Starting Address",
  "trips.startAt":"Start At",
  "trips.endingAddress":"Ending Address",
  "trips.endAt": "End At",
  "trips.totalDistance":"Travel",
};

// work detail report
export const workDetailReportHeaders = [
  "addedAt",
  "shopName",
  "shopOwner",
  "shopState",
  "shopCity",
  "orderJuice",
  "orderWater",
  "outletVisit",
  "totalCases"
];

export const workDetailReportHeaderMapping: { [key: string]: string } = {
  "addedAt": "Date",
  "shopName": "Shop Name",
  "shopOwner": "Shop Owner",
  "shopState":"Shop State",
  "shopCity":"Shop City",
  "orderJuice": "Order Juice",
  "orderWater":"Order Water",
  "outletVisit":"Outlet Visit",
  "totalCases":"Sales"
};

// employee performance report
export const employeePerformanceReportHeaders = [
  "fullName",
  "joiningDate",
  "designation",
  "address.state",
  "reporter",
  "outlet_capture",
  "totalCases",
];

export const employeePerformanceReportHeaderMapping: { [key: string]: string } = {
  "fullName": "Employee",
  "joiningDate": "Joining Date",
  "designation": "Designation",
  "address.state":"State",
  "reporter":"Reporting",
  "outlet_capture": "YTD Outlet",
  "totalCases":"YTD Sales",
};

// party detail report
export const partyDetailReportHeaders = [
  "firmName",
  "directorName",
  "role",
  "address.state",
  "address.city",
  "totalCases",
  "orderAmount",
  "secondaryNumber",
  "lastOrderDate"
];

export const partyDetailReportHeaderMapping: { [key: string]: string } = {
  "firmName": "Party Name",
  "directorName": "Owner Name",
  "role": "Role",
  "address.state":"State",
  "address.city":"City",
  "totalCases":"Stock",
  "orderAmount":"Order Amount",
  "secondaryNumber":"Secondary Number",
  "lastOrderDate":"Last Order Date"
};


// beat export

export const beatFileHeaders = [
  "beatName",
  "city",
  "state",
  "employee",
  "distributors",
  "addedAt",
];

export const beatHeaderMapping: { [key: string]: string } = {
  beatName: "Full Name",
  city: "City",
  state: "State",
  employee: "Employee",
  distributors:"Distributors",
  addedAt: "AddedAt"
};

export const USER_DESIGNATIONS=[
    { label: "Key Account Manager", value: "key account manager" },
    { label: "Zonal Head-Sales", value: "zonal head-sales" },
    { label: "State Head", value: "state head" },
    { label: "RSM", value: "rsm" },
    { label: "ASE", value: "ase" },
    { label: "ASM", value: "asm" },
    { label: "SSE", value: "sse" },
    { label: "SM", value: "sm" },
    { label: "SSO", value: "sso" },
    { label: "SO", value: "so" },
    { label: "JSO", value: "jso" },
    { label: "TSI", value: "tsi" },
    { label: "SR", value: "sr" },
    { label: "SE", value: "se" },
    { label: "PSR", value: "psr" },
    { label: "MD", value: "md" },  
    { label: "ZSM", value: "zsm" }  
];